<template>
  <div>
    <div class="row m-b-20 m-t-20">
      <div class="col-xs-12 col-sm-3 col-md-3 control-label" />
      <div class="col-xs-4 col-md-3 col-lg-2 col-xl-2">
        <table class="table_beauty concurrency-matrix">
          <thead>
            <tr>
              <th class="col-md-1 p-0 p-r-10 text-right no-text-transformation">
                {{ $t('WEEKDAY') }}
              </th>
              <th
                class="text-right p-0 p-r-10"
              >
                {{ $t('CAP') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-right p-0 p-r-10 min-width-40"> 
                {{ $t('ALL') }}
              </td>
              <td
                class="p-0 text-right"
              >
                <div class="col-md-12 in-table-currency-field">
                  <span
                    v-if="isCurrency"
                    class="currency currency-with-toggle ng-scope"
                  >$</span>
                  <input
                    type="number"
                    :value="allDays"
                    min="0"
                    placeholder="∞"
                    class="form-control"
                    :readonly="isReadOnly"
                    @input="allDaysUpdate($event)"
                  >
                </div>
              </td>
            </tr>
            <tr
              v-for="(day, dayIndex) in daysOfWeek"
              :key="dayIndex"
            >
              <td class="text-right p-0 p-r-10">
                {{ day }}
              </td>
              <td
                class="p-0 text-center"
              >
                <div class="col-md-12 in-table-currency-field">
                  <span
                    v-if="isCurrency"
                    class="currency currency-with-toggle ng-scope"
                  >$</span>
                  <input
                    type="number"
                    :value="matrix[dayIndex]"
                    min="0"
                    placeholder="∞"
                    class="form-control"
                    :readonly="isReadOnly"
                    @input="dayOfWeekUpdate(dayIndex, $event)"
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import messages from './locales';

export default {
  props: {
    matrix: {
      required: true,
      type: Array,
    },
    allDays: {
      type: Number,
      default: undefined,
    },
    isReadOnly: {
      type: Boolean,
      default: false
    },
    isCurrency: {
      type: Boolean,
      default: false
    }
  },
  beforeCreate: function () {
    this.daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  },
  methods: {
    dayOfWeekUpdate: function (day, $event) {
      var value = parseInt($event.target.value);
      if (isNaN(value)) value = undefined;
      this.$emit('matrixDayNeedsUpdate', { day, value });
    },
    allDaysUpdate: function ($event) {
      var value = parseInt($event.target.value);
      if (isNaN(value)) value = undefined;
      this.$emit('matrixDaysNeedsUpdate', value);
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style scoped>
.in-table-currency-field {
  padding-left: 0px;
  padding-right: 0px;
}
</style>